import { createContext } from "react";

export const ThreadContext = createContext(null);
